var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { isValidField } from "../Utils";
import FormComponent from "./FormComponent";
var ChatForm = function (props) {
    var formFields = props.formFields, setTypeText = props.setTypeText, submitChatForm = props.submitChatForm, setFormFields = props.setFormFields, typeText = props.typeText;
    var _a = useState(false), saving = _a[0], setSaving = _a[1];
    var handleFieldValueChange = function (value, field) {
        var results = formFields.map(function (eachField) {
            if (eachField === field) {
                if (eachField.type === "checkbox") {
                    if (!eachField.valueArr)
                        eachField.valueArr = [];
                    if (!value && eachField.valueArr.length == 1)
                        eachField.valueArr.splice(0, 1);
                    else
                        eachField.valueArr.push(value);
                    eachField.value = eachField.valueArr;
                }
                else if (eachField.type === "multicheckbox"
                // ||
                // eachField.type === "checkbox"
                ) {
                    if (!eachField.valueArr)
                        eachField.valueArr = [];
                    if (eachField.valueArr.includes(value)) {
                        var index = eachField.valueArr.indexOf(value);
                        if (index > -1) {
                            eachField.valueArr.splice(index, 1);
                        }
                    }
                    else
                        eachField.valueArr.push(value);
                    eachField.value = eachField.valueArr;
                }
                else {
                    eachField.value = value;
                }
                if (eachField.error)
                    eachField = isValidField(eachField);
                if (eachField.field_type == "SYSTEM" && field.name == "message")
                    setTypeText(value);
            }
            return eachField;
        });
        setFormFields(results);
    };
    var submitForm = function () {
        if (isvalidForm() && !saving) {
            // Set field data in to storage
            setSaving(true);
            var obj_1 = {};
            formFields.map(function (field) {
                if (field.value)
                    obj_1[field.name] = field.value;
            });
            // console.log("formdata", obj);
            submitChatForm(obj_1);
        }
    };
    var isvalidForm = function () {
        var isValid = true;
        var results = formFields.map(function (field) {
            field = isValidField(field);
            if (isValid)
                isValid = field.is_valid;
            return field;
        });
        setFormFields(results);
        return isValid;
    };
    return (_jsx("div", __assign({ className: "chat_agent_data", style: { display: "flex" } }, { children: _jsx(FormComponent, { typeText: typeText, formFields: formFields, handleFieldValueChange: handleFieldValueChange, saving: saving, submitForm: submitForm }) })));
};
export default ChatForm;
